// extracted by mini-css-extract-plugin
export var discard = "_4s-3";
export var muiTooltipTooltip = "_4s-5";
export var notificationBar = "_4s-2";
export var saveButtonHoverSlotWrapper = "_4s-4";
export var show = "_4s-1";
export var spacer = "_4s-0";